import React, { useState } from 'react';
import './DestSingle.css';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle, Tour, Accommodation, Activity } from '../../../components';
import { accommodations, activities } from '../../../constants';
import { filterToursByLocation, getItemsByIds } from '../../../utils';

// Import FontAwesome icon
import { FaCloudSun, FaMountain } from 'react-icons/fa';
import { FaTent } from 'react-icons/fa6';

import { useLocation } from 'react-router-dom';



const DestSingle = () => {

  // State to manage the active tab
  const [activeTab, setActiveTab] = useState('overview');

  // Function to handle tab switching
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Get destination data passed from the previous page
  const location = useLocation();
  const destination = location.state;

  // Destination Tours
  const desTours = filterToursByLocation(destination.title);

  // Destination Accommodations
  const desAccommodations = getItemsByIds(destination.accommodationsIds, accommodations);

  // Destination Activities
  const desActivities = getItemsByIds(destination.activitiesIds, activities);

  const encodedQuery = encodeURIComponent(destination.title);
  return (
    <>

      {/* Page Title Section */}
      <PageTitle title={destination.title} page={'Destination Single'} />

      <section className='des-single page-single'>

        <div className="des-info page-info">

          {/* Destination Image */}
          <div className="image">
            <img src={destination.image} alt={destination.title} />
          </div>

          {/* Destination Content */}
          <div className="content tab-info">

            {/* Destination Info Tabs - Tab Buttons */}
            <div className="destination-info-tabs tab-buttons">
              <button 
                type="button" 
                className={`button ${activeTab === 'overview' ? 'active' : ''}`} 
                onClick={() => handleTabClick('overview')}
              >
                Overview
              </button>
              <button 
                type="button" 
                className={`button ${activeTab === 'tours' ? 'active' : ''}`} 
                onClick={() => handleTabClick('tours')}
              >
                Tours
              </button>
              <button 
                type="button" 
                className={`button ${activeTab === 'accommodations' ? 'active' : ''}`} 
                onClick={() => handleTabClick('accommodations')}
              >
                Accommodations
              </button>
              <button 
                type="button" 
                className={`button ${activeTab === 'activities' ? 'active' : ''}`} 
                onClick={() => handleTabClick('activities')}
              >
                Activities
              </button>
              <button 
                type="button" 
                className={`button ${activeTab === 'gallery' ? 'active' : ''}`} 
                onClick={() => handleTabClick('gallery')}
              >
                Gallery
              </button>
            </div>

            {/* Destination Info Tabs - Tab Sections */}
            <div className="tab-sections">

              {/* Overview Tab Section */}
              {activeTab === 'overview' && (

                <div className="overview tab-section active">

                  {/* Destination heading */}
                  <h3 className='main-heading'>{destination.title}</h3>

                  {/* Destination Content */}
                  {destination.overviews.map((overview, index) => (
                    <p key={index}>{overview}</p>
                  ))}

                  {/* Climate and Weather */}
                  <div className='climate sub-section'>
        
                    <h3 className='sub-heading'>Climate and Weather:</h3>
        
                    <p>The climate and weather in {destination.title} offer a variety of experiences, ensuring you enjoy:</p>
        
                    {/* List of Climate and Weather */}
                    <ul>
                      {destination.climate.map((item, index) => {
                        return <li key={index}><div className='icon'><FaCloudSun /></div>{item}</li>
                      })}
                    </ul>
        
                  </div>

                  {/* Terrain and Landscape */}
                  <div className='learning-outcomes sub-section'>

                    <h3 className='sub-heading'>Terrain and Landscape:</h3>

                    <p>The terrain and landscape of {destination.title} offer a diverse and captivating experience, allowing you to explore:</p>

                    {/* List of Terrain and Landscape */}
                    <ul>
                      {destination.landscape.map((item, index) => {
                        return <li key={index}><div className='icon'><FaMountain /></div>{item}</li>
                      })}
                    </ul>

                  </div>

                  {/* Camping Facilities */}
                  <div className='prerequisites sub-section'>

                    <h3 className='sub-heading'>Camping Facilities:</h3>

                    <p>The camping facilities in {destination.title} provide a comfortable and enjoyable experience, featuring:</p>

                    {/* List of Camping Facilities */}
                    <ul>
                      {destination.facilities.map((item, index) => {
                        return <li key={index}><div className='icon'><FaTent /></div>{item}</li>
                      })}
                    </ul>

                  </div>

                  {/* Destination Location Map */}
                  <div className="location-map sub-section">
                    <h3 className="sub-heading">Location Map:</h3>
                    <p>Find your way around {destination.title} with the map below:</p>
                    <iframe
                      src={destination.locationMap}
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      title="Destination Venue Map"
                    ></iframe>
                  </div>

                </div>
              )}

              {/* Tours Tab Section */}
              {activeTab === 'tours' && (
                <div className="tours tab-section">
                  <div className='box-container'>
                    {/* Loop through the destination tours array and render each tour */}
                    {desTours.map((tour) => {
                      return <Tour key={tour.id} tour={tour} />
                    })}
                  </div>
                  
                </div>
              )}

              {/* Accommodation Tab Section */}
              {activeTab === 'accommodations' && (
                <div className="accommodations tab-section">
                  <div className='box-container'>

                    {/* Map over the accommodations array to render each accommodation */}
                    {desAccommodations.map((acco) => { 
                      return <Accommodation key={acco.id} acco={acco} />
                    })}

                  </div>
                </div>
              )}

             {/* Activities Tab Section */}
              {activeTab === 'activities' && (
                <div className="activities tab-section">
                  <div className='box-container'>
          
                    {/* Map over the activities array to render each activity */}
                    {desActivities.map((activity) => { 
                      return <Activity key={activity.id} activity={activity} />
                    })}
          
                  </div>
                </div>
              )}

              {/* Gallery Tab Section */}
              {activeTab === 'gallery' && (
                <div className="tab-section">
                  {/* Destination Image gallery */}
                  <Lightbox images={destination.gallery} />
                </div>
              )}

            </div>
          </div>
        </div>

        {/* Sidebar Section */}
        <PageSidebar
          heading={'Destination'}
          details={destination.details}
          button={{ link: `Tours/Search/${encodedQuery}`, title: 'Explore Now' }}
        />

      </section>

     </>
  );
};

export default DestSingle;